import React from "react";

const Pool = () => {
  return (
    <svg
      preserveAspectRatio="xMidYMid meet"
      data-bbox="8.4 27.1 183.1 154"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="8.4 27.1 183.1 154"
      role="img"
      className="content-card__svg"
    >
      <g>
        <path
          d="M188.7,138c-8.2,0-12.2,2.5-16,4.8c-3.6,2.1-7,4.1-13.6,4.1c-6.7,0-10-2-13.6-4.1c-4.3-2.6-8.5-4.8-16-4.8
		c-8.2,0-12.2,2.5-16,4.8c-3.6,2.1-7,4.1-13.6,4.1c-6.7,0-10-2-13.6-4.1c-4.3-2.6-8.5-4.8-16-4.8c-8.2,0-12.2,2.5-16,4.8
		c-3.6,2.1-7,4.1-13.6,4.1c-6.7,0-10-2-13.6-4.1c-4.3-2.6-8.5-4.8-16-4.8c-1.2,0-2.4,1.2-2.4,2.4s1.2,2.4,2.4,2.4
		c6.7,0,10,2,13.6,4.1c4.3,2.6,8.5,4.8,16,4.8c8.2,0,12.2-2.5,16-4.8c3.6-2.1,7-4.1,13.6-4.1c6.7,0,10,2,13.6,4.1
		c4.3,2.6,8.5,4.8,16,4.8c8.2,0,12.2-2.5,16-4.8l0.4-0.2c3.4-2,6.5-3.8,13.2-3.8c6.7,0,10,2,13.6,4.1c4.3,2.6,8.5,4.8,16,4.8
		c8.2,0,12.2-2.5,16-4.8c3.6-2.1,7-4.1,13.6-4.1c1.2,0,2.4-1.2,2.4-2.4S189.9,138,188.7,138z"
        ></path>
        <path
          d="M10.9,128.4c6.7,0,10,2,13.6,4.1c4.3,2.6,8.5,4.8,16,4.8c8.2,0,12.2-2.5,16-4.8c3.6-2.1,7-4.1,13.6-4.1
		c6.7,0,10,2,13.6,4.1c4.3,2.6,8.5,4.8,16,4.8c8.2,0,12.2-2.5,16-4.8l0.4-0.2c3.4-2,6.5-3.8,13.2-3.8c6.7,0,10,2,13.6,4.1
		c4.3,2.6,8.5,4.8,16,4.8c8.2,0,12.2-2.5,16-4.8c3.6-2.1,7-4.1,13.6-4.1c1.2,0,2.4-1.2,2.4-2.4c0-1.2-1.2-2.4-2.4-2.4
		c-8.2,0-12.2,2.5-16,4.8c-3.6,2.1-7,4.1-13.6,4.1c-6.7,0-9.9-2-13.5-4.1c-4.3-2.6-8.7-4.8-15.7-4.8V47.3
		c0-11.1-10.1-20.2-21.2-20.2c-1.2,0-2.9,1.2-2.9,2.4c0,1.2,2,2.4,3.2,2.4c8.3,0,15.9,6.8,15.9,15.1v10H76v-9.7
		c0-10.7-8.6-18.4-20.3-18.4c-1.2,0-2.5,1.2-2.5,2.4c0,1.2,1.1,2.4,2.3,2.4c4.2,0,8.3,1.3,10.7,3.4c3,2.7,4.7,6.1,4.7,9.9v76.8
		c0,0-0.6-0.1-1.2-0.1c-8.2,0-11.9,2.5-15.8,4.8c-3.6,2.1-6.9,4.1-13.5,4.1c-6.7,0-10-2-13.6-4.1c-4.3-2.6-8.4-4.8-16-4.8
		c-1.2,0-2.4,1.2-2.4,2.4C8.5,127.3,9.7,128.4,10.9,128.4z M76,62h49v19H76V62z M76,86h49v20H76V86z M76,111h49v13
		c-6,0.7-8.4,2.6-11.4,4.5c-3.6,2.1-7,4.1-13.7,4.1c-6.7,0-10.4-2-14-4.1c-2.9-1.8-5.9-3.3-9.9-4.2V111z"
        ></path>
        <path
          d="M10.9,157.4c6.7,0,10,2,13.6,4.1c4.3,2.6,8.5,4.8,16,4.8c8.2,0,12.2-2.5,16-4.8c3.6-2.1,7-4.1,13.6-4.1
		c6.7,0,10,2,13.6,4.1c4.3,2.6,8.5,4.8,16,4.8c8.2,0,12.2-2.5,16-4.8l0.4-0.2c3.4-2,6.5-3.8,13.2-3.8c6.7,0,10,2,13.6,4.1
		c4.3,2.6,8.5,4.8,16,4.8c8.2,0,12.2-2.5,16-4.8c3.6-2.1,7-4.1,13.6-4.1c1.2,0,2.4-1.2,2.4-2.4c0-1.2-1.2-2.4-2.4-2.4
		c-8.2,0-12.2,2.5-16,4.8c-3.6,2.1-7,4.1-13.6,4.1c-6.7,0-10-2-13.6-4.1c-4.3-2.6-8.5-4.8-16-4.8c-8.2,0-12.2,2.5-16,4.8
		c-3.6,2.1-7,4.1-13.6,4.1c-6.7,0-10-2-13.6-4.1c-4.3-2.6-8.5-4.8-16-4.8c-8.2,0-12.2,2.5-16,4.8c-3.6,2.1-7,4.1-13.6,4.1
		c-6.7,0-10-2-13.6-4.1c-4.3-2.6-8.5-4.8-16-4.8c-1.2,0-2.4,1.2-2.4,2.4C8.5,156.2,9.7,157.4,10.9,157.4z"
        ></path>
        <path
          d="M189.1,167.3c-8.2,0-12.2,2.5-16,4.8c-3.6,2.1-7,4.1-13.6,4.1c-6.7,0-10-2-13.6-4.1c-4.3-2.6-8.5-4.8-16-4.8
		c-8.2,0-12.2,2.5-16,4.8c-3.6,2.1-7,4.1-13.6,4.1c-6.7,0-10-2-13.6-4.1c-4.3-2.6-8.5-4.8-16-4.8c-8.2,0-12.2,2.5-16,4.8
		c-3.6,2.1-7,4.1-13.6,4.1s-10-2-13.6-4.1c-4.3-2.6-8.5-4.8-16-4.8c-1.2,0-2.4,1.2-2.4,2.4c0,1.2,1.2,2.4,2.4,2.4
		c6.7,0,10,2,13.6,4.1c4.3,2.6,8.5,4.8,16,4.8c8.2,0,12.2-2.5,16-4.8c3.6-2.1,7-4.1,13.6-4.1c6.7,0,10,2,13.6,4.1
		c4.3,2.6,8.5,4.8,16,4.8c8.2,0,12.2-2.5,16-4.8l0.4-0.2c3.4-2,6.5-3.8,13.2-3.8c6.7,0,10,2,13.6,4.1c4.3,2.6,8.5,4.8,16,4.8
		c8.2,0,12.2-2.5,16-4.8c3.6-2.1,7-4.1,13.6-4.1c1.2,0,2.4-1.2,2.4-2.4C191.5,168.4,190.3,167.3,189.1,167.3z"
        ></path>
      </g>
    </svg>
  );
};

export default Pool;
